import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=logged out

  useEffect(() => {
    // CRITICAL: skip /me check saat kembali dari Google OAuth callback — AuthCallback yang memproses session_id dulu
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  }, []);

  const googleLogin = useCallback(async (sessionId) => {
    const { data } = await api.post("/auth/google-session", { session_id: sessionId });
    setUser(data);
    return data;
  }, []);

  const unlock = useCallback(async (pin) => {
    await api.post("/auth/unlock", { pin });
    const { data } = await api.get("/auth/me");
    setUser(data);
  }, []);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) { /* abaikan */ }
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, googleLogin, unlock, refreshUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
